export default () => {
  // checkDate
  const cardList = [
    {
      name: "pre-order",
      dates: {
        start: "2024-08-05",
        end: "2024-08-11",
      },
    },
    {
      name: "order",
      dates: {
        start: "2024-08-12",
        end: "2024-09-29",
      },
    },
    {
      name: "last-chance",
      dates: {
        start: "2024-09-30",
        end: "2024-10-04",
      },
    },
  ];

  function checkDate() {
    const currentDate = new Date().toISOString().split("T")[0];

    cardList.forEach((el) => {
      const startDate = new Date(el.dates.start).toISOString().split("T")[0];
      const endDate = new Date(el.dates.end).toISOString().split("T")[0];
      const card = document.querySelector(`.card[data-name="${el.name}"]`);

      if (currentDate >= startDate && currentDate <= endDate) {
        card.classList.remove("disabled");
      } else {
        card.classList.add("disabled");
      }
    });
  }

  checkDate();
};
